<div class="frontpage-widget cover-image-trees-gray">
    <div class="whitebox dark-blue">
        <div class="container">
            <p class="text-muted">SCREENING
                <i class="fa fa-chevron-right"></i>
            </p>
            <h2>{{screeningResult?.location?.name}}</h2>
            <p><span class="text-muted" i18n>Lokalitetsnummer:</span>
                <a [routerLink]="['/screening/location-details/', screeningResult?.location?.id]">
                    {{screeningResult?.location?.number}}
                </a>
            </p>
        </div>
    </div>
</div>
<div *ngIf="screeningResult" class="container">
    <div class="row mt-5">
        <div class="col-lg-3">
            <div class="form-group">
                <label for="polutant">Kortlægning:</label>
                <div class="result-value">
                    <span i18n>{{getPolygonTypeString(screeningResult.polygonType)}}</span>
                    <span class="text-muted">
                        (kortlagt areal:
                        {{getValidNumber(screeningResult.polygonArea) | number:'1.0-2':'da'}}
                        m<sup>2</sup>)
                    </span>
                </div>
            </div>
        </div>
        <div class="col-lg-3">
            <div class="form-group">
                <label for="polutant">Screeningsresultat:</label>
                <div class="result-value">
                    <div class="risk-indicator-screening" [ngClass]="{
                      'no-risk': screeningResult.factor <= 1,
                      'risk': (screeningResult.factor > 1)}"></div>

                    <span i18n> Maksimal overskridelse:
                        <b
                            [ngClass]="{'text-danger':screeningResult.factor > 1}">{{getFactor(screeningResult.factor, screeningResult.qualityCriterion, screeningResult. conc100mGrundRisk)}}</b>
                    </span>
                </div>
            </div>
        </div>
    </div>
    <div class="row mt-4">
        <div class="col">
            <div class="form-group">
                <label for="polutant">Flag:</label>
                <div class="result-value">
                    <div class="row">
                        <div *ngIf="!hasAnyFlags()" class="col-lg-6">
                            <span class="text-muted"><i class="fa fa-thumbs-up fa-lg"></i>
                                Ingen flag på denne lokalitet
                            </span>
                        </div>
                        <div class="col-lg-6" *ngIf="hasFlag(screeningFlag.Bly_kobber_eller_PAH)">
                            <i class="fa fa-flag text-danger"></i>
                            <span i18n>Bly, kobber eller PAH fjernet i trin 1</span>
                        </div>
                        <div class="col-lg-6" *ngIf="hasFlag(screeningFlag.Kompleks_geologi)">
                            <i class="fa fa-flag text-danger"></i>
                            <span i18n>Område med kompleks geologi</span>
                        </div>
                        <div class="col-lg-6" *ngIf="hasFlag(screeningFlag.Manglende_modelstof)">
                            <i class="fa fa-flag text-danger"></i>
                            <span i18n>Et eller flere forureningsstoffer mangler et modelstof</span>
                        </div>
                        <div class="col-lg-6" *ngIf="hasFlag(screeningFlag.Svag_geologi)">
                            <i class="fa fa-flag text-danger"></i>
                            <span i18n>Svag datadækning for bestemmelse af dæklagstykkelser</span>
                        </div>
                        <div class="col-lg-6" *ngIf="hasFlag(screeningFlag.MTBE_fjernet)">
                            <i class="fa fa-flag text-danger"></i>
                            <span i18n>MTBE fjernet</span>
                        </div>
                        <div class="col-lg-6" *ngIf="hasFlag(screeningFlag.Boring_uden_ler)">
                            <i class="fa fa-flag text-danger"></i>
                            <span i18n>Lokalitet har boring uden ler i en radius af 100-300 m fra kant</span>
                        </div>
                        <div class="col-lg-6" *ngIf="hasFlag(screeningFlag.Risiko_pga_vandindvinding)">
                            <i class="fa fa-flag text-danger"></i>
                            <span i18n>
                                Lokalitet udgør en risiko fordi der ligger en vandindvindingsboring indenfor 100 m
                            </span>
                        </div>
                        <div class="col-lg-6" *ngIf="hasFlag(screeningFlag.Kun_Olie_Benzin_Stoffer)">
                            <i class="fa fa-flag text-danger"></i>
                            <span i18n>
                                Lokalitet er udelukkende forurenet med olie- og benzin stoffer
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row mt-4">
        <div class="col">
            <div class="form-group">
                <label for="polutant">Stof:</label>
                <div class="result-value">
                    <h3 i18n>{{screeningResult.compoundName}}</h3>
                </div>
            </div>
        </div>
    </div>

    <div class="row mt-2">
        <div *ngIf="screeningResult.polygonType == polygonType.V1" class="col-lg-2">
            <div class="form-group break-word">
                <label for="polutant">Branche:</label>
                <div class="result-value">
                    {{screeningResult.industry.name}}
                </div>
            </div>
        </div>

        <div *ngIf="screeningResult.polygonType == polygonType.V1" class="col-lg-3">
            <div class="form-group break-word">
                <label for="polutant">Aktivitet:</label>
                <div class="result-value">
                    {{screeningResult.activity.name}}
                </div>
            </div>
        </div>
    </div>

    <div class="mt-4">
        <h4 i18n>Beregningsparameter</h4>
        <hr />

        <div class="row mt-2" *ngIf="standardParameters">
            <div class="col-lg-4 col-sm-6">
                <div class="form-group break-word">
                    <label for="polutant">Infiltration
                        <span *ngIf="standardParameters.infiltration === 100">(*)</span>:
                    </label>
                    <div class="result-value">
                        <span *ngIf="standardParameters.infiltration">
                            {{standardParameters.infiltration | number:'1.2-2'}} mm/år
                        </span>
                        <small class="text-muted" *ngIf="!standardParameters.infiltration">
                            Vi kunne ikke finde infiltration for denne lokalitet
                        </small>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-sm-6">
                <div class="form-group break-word">
                    <label for="polutant">Hydraulisk gradient i førstkommende grundvandsmagasin
                        <span *ngIf="standardParameters.headGradient === 0.007">(*)</span>:
                    </label>
                    <div class="result-value">
                        <span *ngIf="standardParameters.headGradient">
                            {{standardParameters.headGradient | number:'1.2-3'}}
                        </span>
                        <small class="text-muted" *ngIf="!standardParameters.headGradient">
                            Vi kunne ikke finde hydraulisk graidient for denne lokalitet
                        </small>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-sm-6">
                <div class="form-group break-word">
                    <label for="polutant">Dybde til grundvandsmagasin
                        <span *ngIf="standardParameters.aquiferDepth === 1">(*)</span>:
                    </label>
                    <div class="result-value">
                        <span *ngIf="standardParameters.aquiferDepth">
                            {{standardParameters.aquiferDepth | number:'1.2-2'}} m
                        </span>
                        <small class="text-muted" *ngIf="!standardParameters.aquiferDepth">
                            Vi kunne ikke finde magasindybde for denne lokalitet
                        </small>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-sm-6">
                <div class="form-group break-word">
                    <label for="polutant">Horisontal hydraulisk konduktivitet i førstkommende grundvandsmagasin
                        <span *ngIf="standardParameters.lithoCode === -9999">(*)</span>:
                    </label>
                    <div class="result-value">
                        <span *ngIf="standardParameters.horizontalHydraulicConductivity">
                            {{standardParameters.horizontalHydraulicConductivity | number:'1.2-6'}} m/s
                        </span>
                        <small class="text-muted" *ngIf="!standardParameters.horizontalHydraulicConductivity">
                            Vi kunne ikke finde horisontal hydraulisk konduktivitet i førstkommende grundvandsmagasin for denne lokalitet
                        </small>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-sm-6">
                <div class="form-group break-word">
                    <label for="polutant">Porøsitet
                        <span *ngIf="standardParameters.lithoCode === -9999">(*)</span>:
                    </label>
                    <div class="result-value">
                        <span *ngIf="standardParameters.porosity">
                            {{standardParameters.porosity | number:'1.2-2'}}
                        </span>
                        <small class="text-muted" *ngIf="!standardParameters.porosity">
                            Vi kunne ikke finde porøsitet for denne lokalitet
                        </small>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-sm-6">
                <div class="form-group break-word">
                    <label for="polutant">Nedbrydningsrate:</label>
                    <div class="result-value">
                        <span *ngIf="standardParameters.firstOrderDegradationRate != null">
                            {{standardParameters.firstOrderDegradationRate | number:'1.2-3'}} d<sup>-1</sup>
                        </span>
                        <small class="text-muted" *ngIf="standardParameters.firstOrderDegradationRate == null">
                            Vi kunne ikke finde nedbrydningsrate for denne lokalitet
                        </small>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-sm-6">
                <div class="form-group break-word">
                    <label for="polutant">Afstand til nærmeste indvinding
                        <span *ngIf="standardParameters.distNearestWaterWell === 1000">(*)</span>:
                    </label>
                    <div class="result-value">
                        <div class="result-value">
                            <span *ngIf="standardParameters.distNearestWaterWell === 1000">
                                Afstand større end 1000 m
                            </span>
                            <span *ngIf="standardParameters.distNearestWaterWell !== 1000">
                                {{standardParameters.distNearestWaterWell | number:'1.0-2'}} m
                            </span>
                            <small class="text-muted" *ngIf="standardParameters.distNearestWaterWell == null">
                                Vi kunne ikke finde 'Afstand til nærmeste indvinding' for denne lokalitet
                            </small>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-sm-6">
                <div class="form-group break-word">
                    <label for="polutant">Afstand til nærmeste boring uden ler i dæklag
                        <span *ngIf="standardParameters.distNoClay === 1000">(*)</span>:
                    </label>
                    <div class="result-value">
                        <div class="result-value">
                        <span *ngIf="standardParameters.distNoClay===1000">
                            Afstand større end 1000 m
                        </span>
                        <span *ngIf="standardParameters.distNoClay !== 1000">
                            {{standardParameters.distNoClay | number:'1.0-2'}} m
                        </span>
                        <small class="text-muted" *ngIf="standardParameters.distNoClay == null">
                            Vi kunne ikke finde 'Afstand til nærmeste boring uden ler i dæklag' for denne
                            lokalitet</small>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-sm-6">
                <div class="form-group break-word">
                    <label for="polutant"></label>
                    <div class="result-value">
                        <span></span>
                        <small class="text-muted">
                            (*) Parametre markeret med * har fået tildelt en standardværdi. Se beskrivelse og forklaring
                            i Screeningsvejledningen.
                        </small>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="mb-5 mt-4">
        <h4 i18n>Log <small class="text-muted">
                (seneste screening: <span>{{screeningResult.createdAt | date:'d/M-yyyy HH:mm'}}</span>)</small>
        </h4>
        <hr />

        <div class="card border-light d-inline-block">
            <div class="card-body m-3">
                <!-- STEP 0 -->
                <div class="row mt-2 ">
                    <div class="col">
                        <h6 i18n>
                            <i *ngIf="!removedInStep(screeningResult, 0)"
                                class="text-danger fa fa-exclamation-circle"></i>
                            <i *ngIf="removedInStep(screeningResult, 0)" class="text-success fa fa-circle"></i>
                            Trin 0
                            <span class="text-muted">
                                - Udvælgelse af de relevante screeninger
                            </span>
                        </h6>
                        <!-- 0.1 Green -->
                        <div *ngIf="removedInSubStep(screeningResult, 0, 1)" class="ml-5 my-3">
                            <p class="log-sub-step-header">
                                <i class="text-success fa fa-circle"></i> Trin 0.1 <span class="text-muted">
                                    - Stoffet er ikke tilknyttet et modelstof
                                </span>
                            </p>
                        </div>
                        <!-- 0.1 Red -->
                        <div *ngIf="!removedInSubStep(screeningResult, 0, 1)" class="ml-5 my-3">
                            <p class="log-sub-step-header">
                                <i class="text-danger fa fa-exclamation-circle"></i> Trin 0.1
                                <span class="text-muted">
                                    - Regionen har udpeget lokaliteten til at være i indsats overfor grundvand
                                </span>
                            </p>
                        </div>
                    </div>
                </div>

                <!-- STEP 1 -->
                <ng-container *ngIf="!removedBeforeStep(screeningResult, 1)">
                    <div class="row mt-2 ">
                        <div class="col">
                            <h6 i18n>
                                <i *ngIf="!removedInStep(screeningResult, 1)"
                                    class="text-danger fa fa-exclamation-circle"></i>
                                <i *ngIf="removedInStep(screeningResult, 1)" class="text-success fa fa-circle"></i>
                                Trin 1
                                <span class="text-muted">
                                    - Forureningsstof
                                </span>
                            </h6>
                            <!-- 1.1 Green -->
                            <div *ngIf="removedInSubStep(screeningResult, 1, 1)" class="ml-5 my-3">
                                <p class="log-sub-step-header">
                                    <i class="text-success fa fa-circle"></i> Trin 1.1
                                    <span class="text-muted">
                                        Stoffet udgør ikke en risiko
                                    </span>
                                </p>
                                <p *ngIf="screeningResult.removalReason == removalReason.Removed_0_1"
                                    class="log-details">
                                    <i class="fa fa-minus fa-lg text-muted"></i>
                                    Lokaliteten har været omfattet af Oliebranchens Miljøpulje (OM) og det antages at OM
                                    har håndteret MTBE forureningen
                                </p>
                                <p *ngIf="screeningResult.removalReason == removalReason.Removed_0_2"
                                    class="log-details">
                                    <i class="fa fa-minus fa-lg text-muted"></i>
                                    MTBE er fjernet grundet aktiviteter vedr. værksted/olie
                                </p>
                                <p *ngIf="screeningResult.removalReason == removalReason.Removed_1_2"
                                    class="log-details">
                                    <i class="fa fa-minus fa-lg text-muted"></i>
                                    Stoffet antages at have en lav mobilitet i jord og grundvand og vurderes ikke at
                                    udgøre et problem for grundvandet
                                </p>
                                <p *ngIf="screeningResult.removalReason == removalReason.Removed_1_1"
                                    class="log-details">
                                    <i class="fa fa-minus fa-lg text-muted"></i>
                                    Der er ikke udført screeningsberegninger for jern, ammonium, kemisk iltforbrug,
                                    NVOC, da det er stoffer der typisk ikke laves vurdering for i forhold til grundvand
                                </p>
                            </div>
                            <!-- 1.1 Red V2 -->
                            <div *ngIf="screeningResult.polygonType == polygonType.V2 && !removedInSubStep(screeningResult, 1, 1)"
                                class="ml-5 my-3">
                                <p class="log-sub-step-header">
                                    <i class="text-danger fa fa-exclamation-circle"></i> Trin 1.1
                                    <span class="text-muted">
                                        - Stoffet kan udgøre en grundvandsrisiko
                                    </span>
                                </p>
                                <p class="log-details" *ngIf="screeningResult.qualityCriterionType === qualityCriterionTypeEnum.GVK">
                                    <i class="fa fa-minus fa-lg text-muted"></i>
                                    Grundvandskvalitetskriterie:
                                    {{getValidNumber(screeningResult.qualityCriterion) | number:'1.0-2':'da'}}
                                </p>
                                <p class="log-details" *ngIf="screeningResult.qualityCriterionType === qualityCriterionTypeEnum.DVK">
                                    <i class="fa fa-minus fa-lg text-muted"></i>
                                    Drikkevandskvalitetskriterie:
                                    {{getValidNumber(screeningResult.qualityCriterion) | number:'1.0-2':'da'}}
                                </p>
                                <p class="log-details" *ngIf="screeningResult.qualityCriterionType === qualityCriterionTypeEnum.Fictitious">
                                    <i class="fa fa-minus fa-lg text-muted"></i>
                                    Fiktivit kriterie:
                                    {{getValidNumber(screeningResult.qualityCriterion) | number:'1.0-2':'da'}}
                                </p>
                                <p class="log-details">
                                    <i class="fa fa-minus fa-lg text-muted"></i>
                                    Worst case koncentration:
                                    {{getValidNumber(screeningResult.worstCaseConcentration) | number:'1.0-2':'da'}}
                                    μg/L
                                    <span *ngIf="screeningResult.concentrationOrigin">
                                        <br />
                                        <ul class="log-details-list">
                                            <li *ngIf="screeningResult.concentrationOrigin === concentrationOriginEnum.Standard">
                                                <i class="fa fa-minus fa-lg text-muted"></i>
                                                Default koncentration for stof
                                            </li>
                                            <li *ngIf="screeningResult.concentrationOrigin === concentrationOriginEnum.Activity">
                                                <i class="fa fa-minus fa-lg text-muted"></i>
                                                Koncentration specifik for aktivitetstype
                                            </li>
                                            <li *ngIf="screeningResult.concentrationOrigin === concentrationOriginEnum.PollutionCause">
                                                <i class="fa fa-minus fa-lg text-muted"></i>
                                                Koncentration specifik for branche
                                            </li>
                                        </ul>
                                    </span>
                                </p>
                                <p class="log-details">
                                    <i class="fa fa-minus fa-lg text-muted"></i>
                                    Kortlagte areal:
                                    {{getValidNumber(screeningResult.polygonArea) | number:'1.0':'da'}} m<sup>2</sup>
                                </p>
                                <p class="log-details">
                                    <i class="fa fa-minus fa-lg text-muted"></i>
                                    Kildestørrelse:
                                    {{getValidNumber(screeningResult.sourceSize) | number:'1.0':'da'}} m<sup>2</sup>
                                </p>
                            </div>
                            <!-- 1.1 Red V1 -->
                            <div *ngIf="screeningResult.polygonType == polygonType.V1 && !removedInSubStep(screeningResult, 1, 1)"
                                class="ml-5 my-3">
                                <p class="log-sub-step-header">
                                    <i class="text-danger fa fa-exclamation-circle"></i> Trin 1.1
                                    <span class="text-muted">
                                        - Branchen/aktiviteten kan udgøre en grundvandsrisiko
                                    </span>
                                </p>
                                <p class="log-details" *ngIf="screeningResult.qualityCriterionType === qualityCriterionTypeEnum.GVK">
                                    <i class="fa fa-minus fa-lg text-muted"></i>
                                    Grundvandskvalitetskriterie:
                                    {{getValidNumber(screeningResult.qualityCriterion) | number:'1.0-2':'da'}}
                                </p>
                                <p class="log-details" *ngIf="screeningResult.qualityCriterionType === qualityCriterionTypeEnum.DVK">
                                    <i class="fa fa-minus fa-lg text-muted"></i>
                                    Drikkevandskvalitetskriterie:
                                    {{getValidNumber(screeningResult.qualityCriterion) | number:'1.0-2':'da'}}
                                </p>
                                <p class="log-details" *ngIf="screeningResult.qualityCriterionType === qualityCriterionTypeEnum.Fictitious">
                                    <i class="fa fa-minus fa-lg text-muted"></i>
                                    Fiktivit kriterie:
                                    {{getValidNumber(screeningResult.qualityCriterion) | number:'1.0-2':'da'}}
                                </p>
                                <p class="log-details">
                                    <i class="fa fa-minus fa-lg text-muted"></i>
                                    Worst case koncentration:
                                    {{getValidNumber(screeningResult.worstCaseConcentration) | number:'1.0-2':'da'}}
                                    μg/L
                                    <span *ngIf="screeningResult.concentrationOrigin">
                                        <br />
                                        <ul class="log-details-list">
                                            <li *ngIf="screeningResult.concentrationOrigin === concentrationOriginEnum.Standard">
                                                <i class="fa fa-minus fa-lg text-muted"></i>
                                                Default koncentration for stof
                                            </li>
                                            <li *ngIf="screeningResult.concentrationOrigin === concentrationOriginEnum.Activity">
                                                <i class="fa fa-minus fa-lg text-muted"></i>
                                                Koncentration specifik for aktivitetstype
                                            </li>
                                            <li *ngIf="screeningResult.concentrationOrigin === concentrationOriginEnum.PollutionCause">
                                                <i class="fa fa-minus fa-lg text-muted"></i>
                                                Koncentration specifik for branche
                                            </li>
                                        </ul>
                                    </span>
                                </p>
                                <p class="log-details">
                                    <i class="fa fa-minus fa-lg text-muted"></i>
                                    Forureningskildens standardareal:
                                    {{getValidNumber(screeningResult.polygonArea) | number:'1.0':'da'}} m<sup>2</sup>
                                </p>
                                <p class="log-details">
                                    <i class="fa fa-minus fa-lg text-muted"></i>
                                    Kildestørrelse:
                                    {{getValidNumber(screeningResult.sourceSize) | number:'1.0':'da'}} m<sup>2</sup>
                                </p>
                            </div>
                        </div>
                    </div>
                </ng-container>

                <!-- STEP 2 -->
                <ng-container *ngIf="!removedBeforeStep(screeningResult, 2)">
                    <div class="row mt-2 ">
                        <div class="col">
                            <h6 i18n>
                                <i *ngIf="!removedInStep(screeningResult, 2)"
                                    class="text-danger fa fa-exclamation-circle"></i>
                                <i *ngIf="removedInStep(screeningResult, 2)" class="text-success fa fa-circle"></i>
                                Trin 2
                                <span class="text-muted">
                                    - Vertikal transport
                                </span>
                            </h6>

                            <!-- 2.1 Green -->
                            <div *ngIf="stopAtSubStep(screeningResult, 2, 1) && removedInSubStep(screeningResult, 2, 1)"
                                class="ml-5 my-3">
                                <p class="log-sub-step-header">
                                    <i class="text-success fa fa-circle"></i> Trin 2.1
                                    <span class="text-muted">-
                                        Stoffet udgør ikke en grundvandsrisiko
                                    </span>
                                </p>
                                <p *ngIf="logContains(screeningResult, screeningLogInfo.CoverLayerAdequate)"
                                    class="log-details">
                                    <i class="fa fa-minus fa-lg text-muted"></i>
                                    Dæklaget ned til grundvandet indeholder mere end 5 m fed ler eller 15 m moræneler
                                </p>
                                <p *ngIf="logContains(screeningResult, screeningLogInfo.CoverLayerAdequateForMetals)"
                                    class="log-details">
                                    <i class="fa fa-minus fa-lg text-muted"></i>
                                    Metaller: Dæklaget ned til grundvandet indeholder mere end 5 m fed ler eller 5 m
                                    moræneler
                                </p>

                                <p class="log-details">
                                    <i class="fa fa-minus fa-lg text-muted"></i>
                                    Dæklaget er estimeret til
                                    {{getValidNumber(screeningResult.coverThickness) | number:'1.0-2'}} m
                                </p>
                                <p class="log-details">
                                    <i class="fa fa-minus fa-lg text-muted"></i>
                                    <span> Datagrundlag for estimering af dæklagstykkelse: </span>
                                    <span *ngIf="screeningResult.dataQuality == dataQuality.Strong"
                                        class="text-success">God</span>
                                    <span *ngIf="screeningResult.dataQuality == dataQuality.Medium"
                                        class="text-warning">Medium</span>
                                    <span *ngIf="screeningResult.dataQuality == dataQuality.Weak"
                                        class="text-danger">Dårlig</span>
                                </p>
                            </div>
                            <!-- 2.1 Red -->
                            <div *ngIf="stopAtSubStep(screeningResult, 2, 1) && !removedInSubStep(screeningResult, 2, 1)"
                                class="ml-5 my-3">
                                <p class="log-sub-step-header">
                                    <i class="text-danger fa fa-exclamation-circle"></i> Trin 2.1 <span
                                        class="text-muted">- Stoffet kan
                                        udgøre en grundvandsrisiko</span>
                                </p>

                                <p *ngIf="screeningResult.removalReason == removalReason.Removed_2_4"
                                    class="log-details">
                                    <i class="fa fa-minus fa-lg text-muted"></i>
                                    MTBE fjernet grundet dæklagstykkelsen.
                                </p>

                                <p *ngIf="logContains(screeningResult, screeningLogInfo.CoverLayerInadequate)"
                                    class="log-details">
                                    <i class="fa fa-minus fa-lg text-muted"></i>
                                    Dæklaget ned til grundvandet indeholder mindre end 5 m fed ler eller mindre end 15 m
                                    moræneler
                                </p>
                                <p *ngIf="logContains(screeningResult, screeningLogInfo.CoverLayerIgnoredForPesticides)"
                                    class="log-details">
                                    <i class="fa fa-minus fa-lg text-muted"></i>
                                    For klorerede opløsningsmidler og pesticider er det valgt, at dæklaget uanset
                                    tykkelsen af lerlag ikke udgør en beskyttelse for disse stoffer
                                </p>
                                <p *ngIf="logContains(screeningResult, screeningLogInfo.CoverLayerInadequateForMetals)"
                                    class="log-details">
                                    <i class="fa fa-minus fa-lg text-muted"></i>
                                    Metaller: Dæklaget ned til grundvandet indeholder mindre end 5 m fed ler eller 5 m
                                    moræneler
                                </p>

                                <p class="log-details">
                                    <i class="fa fa-minus fa-lg text-muted"></i> Dæklaget er estimeret til
                                    {{getValidNumber(screeningResult.coverThickness) | number:'1.0-2'}} m
                                </p>
                                <p class="log-details">
                                    <i class="fa fa-minus fa-lg text-muted"></i>
                                    <span> Datagrundlag for estimering af dæklagstykkelse: </span>
                                    <span *ngIf="screeningResult.dataQuality == dataQuality.Strong"
                                        class="text-success">God</span>
                                    <span *ngIf="screeningResult.dataQuality == dataQuality.Medium"
                                        class="text-warning">Medium</span>
                                    <span *ngIf="screeningResult.dataQuality == dataQuality.Weak"
                                        class="text-danger">Dårlig</span>
                                </p>
                                <p *ngIf="logContains(screeningResult, screeningLogInfo.CoverLayerInadequate)"
                                    class="log-details">
                                    <i class="fa fa-minus fa-lg text-muted"></i>
                                    <span> Sker der nedbrydning af stoffet: </span>
                                    <span
                                        *ngIf="logContains(screeningResult, screeningLogInfo.CoverLayerDegradation)">Ja</span>
                                    <span
                                        *ngIf="!logContains(screeningResult, screeningLogInfo.CoverLayerDegradation)">Nej</span>
                                </p>
                            </div>

                            <!-- 2.2 Green -->
                            <div *ngIf="stopAtSubStep(screeningResult, 2, 2) && removedInSubStep(screeningResult, 2, 2)"
                                class="ml-5 my-3">
                                <p class="log-sub-step-header">
                                    <i class="text-success fa fa-circle"></i> Trin 2.2
                                    <span class="text-muted">
                                        - Stoffet overholder grundvandskvalitetskriteriet ved toppen af
                                        grundvandsmagasinet
                                    </span>
                                </p>

                                <p class="log-details">
                                    <i class="fa fa-minus fa-lg text-muted"></i>
                                    Koncentration ved grundvandsspejl:
                                    {{getValidNumber(screeningResult.concTopTables) | number:'1.0-2'}} μg/L
                                </p>
                                <p class="log-details">
                                    <i class="fa fa-minus fa-lg text-muted"></i> Kvalitetskriterie:
                                    {{getValidNumber(screeningResult.qualityCriterion) | number:'1.0-2'}} μg/L
                                </p>
                            </div>
                            <!-- 2.2 Red -->
                            <div *ngIf="stopAtSubStep(screeningResult, 2, 2) && !removedInSubStep(screeningResult, 2, 2)"
                                class="ml-5 my-3">
                                <ng-container *ngIf="logContains(screeningResult, screeningLogInfo.NoQualityCriterion)">
                                    <p class="log-sub-step-header">
                                        <i class="text-danger fa fa-exclamation-circle"></i>Trin 2.2
                                        <span class="text-muted">
                                            - Sammenligning med kriterium ikke foretaget, da stoffet mangler et
                                            kvalitetskriterium
                                        </span>
                                    </p>
                                </ng-container>
                                <ng-container
                                    *ngIf="!logContains(screeningResult, screeningLogInfo.NoQualityCriterion)">
                                    <p class="log-sub-step-header">
                                        <i class="text-danger fa fa-exclamation-circle"></i> Trin 2.2
                                        <span class="text-muted">
                                            - Stoffet overholder ikke grundvandskvalitetskriteriet ved toppen af
                                            grundvandsmagasinet
                                        </span>
                                    </p>

                                    <p class="log-details">
                                        <i class="fa fa-minus fa-lg text-muted"></i>
                                        Koncentration ved grundvandsspejl:
                                        {{getValidNumber(screeningResult.concTopTables) | number:'1.0-2'}} μg/L
                                    </p>
                                    <p class="log-details">
                                        <i class="fa fa-minus fa-lg text-muted"></i> Kvalitetskriterie:
                                        {{getValidNumber(screeningResult.qualityCriterion) | number:'1.0-2'}} μg/L
                                    </p>
                                </ng-container>
                            </div>

                        </div>
                    </div>
                </ng-container>

                <!-- STEP 3 -->
                <ng-container *ngIf="!removedBeforeStep(screeningResult, 3)">
                    <div class="row mt-2 ">
                        <div class="col">
                            <h6 i18n>
                                <i *ngIf="!removedInStep(screeningResult, 3)"
                                    class="text-danger fa fa-exclamation-circle"></i>
                                <i *ngIf="removedInStep(screeningResult, 3)" class="text-success fa fa-circle"></i>
                                Trin 3 <span class="text-muted">- Horisontal transport</span>
                            </h6>

                            <!-- 3.1 Green -->
                            <div *ngIf="removedInSubStep(screeningResult, 3, 1)" class="ml-5 my-3">
                                <p class="log-sub-step-header">
                                    <i class="text-success fa fa-circle"></i> Trin 3.1
                                    <span class="text-muted">
                                        - Beregning foretaget, og viser ingen risiko for grundvandet
                                    </span>
                                </p>

                                <p class="log-details">
                                    <i class="fa fa-minus fa-lg text-muted"></i>
                                    Koncentrationen i det administrative punkt (POC = 100 m):
                                    {{getValidNumber(screeningResult.conc100mGrundRisk) | number:'1.0-2'}} μg/L
                                </p>
                                <p class="log-details">
                                    <i class="fa fa-minus fa-lg text-muted"></i>
                                    Kvalitetskriterie er overskredet med en faktor:
                                    {{getFactor(screeningResult.factor, screeningResult.qualityCriterion, screeningResult.conc100mGrundRisk)}}
                                </p>
                            </div>

                            <!-- 3.1 Red -->
                            <div *ngIf="!removedInSubStep(screeningResult, 3, 1)" class="ml-5 my-3">
                                <p class="log-sub-step-header">
                                    <i class="text-danger fa fa-exclamation-circle"></i> Trin 3.1
                                    <span class="text-muted">
                                        - Beregning foretaget og viser en risiko for grundvandet
                                    </span>
                                </p>

                                <p class="log-details">
                                    <i class="fa fa-minus fa-lg text-muted"></i>
                                    Koncentrationen i det administrative punkt (POC = 100 m):
                                    {{getValidNumber(screeningResult.conc100mGrundRisk) | number:'1.0-2'}} μg/L
                                </p>
                                <p class="log-details">
                                    <i class="fa fa-minus fa-lg text-muted"></i>
                                    Kvalitetskriterie er overskredet med en faktor:
                                    {{getFactor(screeningResult.factor, screeningResult.qualityCriterion, screeningResult.conc100mGrundRisk)}}
                                </p>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>